/* Home — Our story: founder photo zooms while the quote's words light up, then name + button. */
(function () {
  var TYPE = 'home-story';

  function init(root) {
    if (!root || root._hs) return;
    root._hs = true;
    var D = window.Dozzee || {};
    if (!D.gsap || D.reduce) return;
    D.gsap(function (gsap, ST, Split) {
      if (!root.isConnected) return;
      var txt = root.querySelector('[data-story-text]');
      if (!txt) return;
      var sp = Split.create(txt, { type: 'words' });
      root._ctx = gsap.context(function () {
        var ts = gsap.timeline({ scrollTrigger: { trigger: root, start: 'top 35%', end: 'bottom bottom', scrub: 0.5 } });
        ts.fromTo(sp.words, { opacity: 0.16 }, { opacity: 1, stagger: 0.08, duration: 0.25, ease: 'none' }, 0)
          .from(root.querySelectorAll('[data-story-end]'), { autoAlpha: 0, y: 20, stagger: 0.1, duration: 0.4 }, '>-0.1')
          .to({}, { duration: 0.5 });
        var si = root.querySelector('.hs__frame img');
        if (si) ts.fromTo(si, { scale: 1.18 }, { scale: 1, ease: 'none', duration: ts.duration() }, 0);
      }, root);
      root._split = sp;
    });
  }

  function all(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-section-type="' + TYPE + '"]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); });
  else all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-section-type="' + TYPE + '"]'), function (r) {
      if (r._ctx) r._ctx.revert();
      if (r._split) try { r._split.revert(); } catch (er) {}
    });
  });
})();
